// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import VisionMission from './components/VisionMission/VisionMission';
import Services from './components/Services/Services';
import WhyTeezash from './components/WhyTeezash/WhyTeezash';
import TeamSection from './components/Team/TeamSection';
import ResponsiveSvg from './components/ResponsiveSvg/ResponsiveSvg';
import ContactPage from './components/ContactPage/ContactPage';
import Privacy from './components/Legal/Privacy';
import Terms from './components/Legal/Terms';
import './styles/globals.css';

const MainContent = () => (
  <>
    <Header />
    <main>
      <Hero />
      <VisionMission />
      <Services />
      <WhyTeezash />
      <TeamSection />
      <ResponsiveSvg />
      <ContactPage />
    </main>
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<MainContent />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;